export enum COLOR_ACTION_TYPES {
  FETCH_ALL_DATA = "color/FETCH_ALL_DATA",
  UPDATE_COLOR = "color/UPDATE_COLOR",
  ADD_COLOR = "color/ADD_COLOR",
  DELETE_COLOR = "color/DELETE_COLOR",
  SET_IS_LOADING = "color/SET_IS_LOADING",
}
